angular.module('dnecom')
    .controller('StoreMenuAppearanceSettingsController', ["$scope", "wizardModal", "$http", "notifications", "$timeout", function ($scope, wizardModal, $http, notifications, $timeout) {
        $scope.menuItemsToRemove = {};

        var assignMenuItemsPositions = function () {
            $('#menu-items-list').find('.menu-item:not(.ui-not-sortable)').each(function (index) {
                $scope.store.properties.menus[$(this).data('id')].position = index;
            });
        };

        $scope.initSortable = function () {
            $('#menu-items-list').sortable({
                cursor: "move",
                containment: "parent",
                axis: "y",
                items: ".menu-item:not(.ui-not-sortable)",
                placeholder: 'mi-placeholder',
                stop: function () {
                    $timeout(function () {
                        assignMenuItemsPositions();

                        // there's a bug that sometimes causes sortable to start ordering items in a wrong way;
                        // to avoid it, we reset the whole thing after each rearranging
                        $('#menu-items-list').sortable('destroy');
                        $scope.initSortable();
                    });
                }
            }).disableSelection();
        };

        $(document).ready(function () {
            $scope.initSortable();
        });

        $scope.addMenuItem = function () {
            var modal = $scope.prepareMenuItemModal({
                'isBuiltin': '0',
                'isActive': '0',
                'label': null,
                'url': '',
                'isNew': '1',
                'openInNewWindow': '1'
            });

            modal.result.then(function (menuItem) {
                menuItem.id = _.snakeCase(menuItem.label);

                if (_.has($scope.store.properties.menus, menuItem.id)) {
                    notifications.danger("Menu item with this label already exists.");

                    return;
                }

                $scope.store.properties.menus[menuItem.id] = menuItem;
            });
        };

        $scope.editMenuItem = function (menuItem) {
            if (!_.has($scope.store.properties.menus, menuItem.id)) {
                return;
            }

            var modal = $scope.prepareMenuItemModal(menuItem, true);

            modal.result.then(function (editedMenuItem) {
                menuItem.label = editedMenuItem.label;
                menuItem.url = editedMenuItem.url;
                menuItem.openInNewWindow = editedMenuItem.openInNewWindow;
            });
        };

        $scope.removeMenuItem = function (menuItem) {
            if (!_.has($scope.store.properties.menus, menuItem.id)) {
                return;
            }

            _.unset($scope.store.properties.menus, menuItem.id);

            if (_.isUndefined(menuItem.isNew)) {
                $scope.menuItemsToRemove[menuItem.id] = menuItem;
            }
        };

        $scope.prepareMenuItemModal = function (currentMenuItem, isInEditMode) {
            if (_.isUndefined(isInEditMode)) {
                isInEditMode = false;
            }

            return wizardModal.open({
                'templateUrl': 'menuItemModal.html',
                'size': 'md',
                'controller': function ($scope, $uibModalInstance, menuItem, isInEditMode) {
                    $scope.menuItem = menuItem;
                    $scope.isInEditMode = isInEditMode;

                    $scope.save = function (form) {
                        if (form.$invalid || form.$pending) {
                            form.$setTouched();

                            return false;
                        }

                        $uibModalInstance.close($scope.menuItem);
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                'resolve': {
                    'menuItem': function () {
                        return angular.copy(currentMenuItem);
                    },
                    'isInEditMode': function () {
                        return isInEditMode;
                    }
                }
            });
        };

        $scope.save = function (form) {
            assignMenuItemsPositions();

            if (!_.isEmpty($scope.menuItemsToRemove)) {
                var url = Routing.generate('stores_settings_delete_menu_items', {
                    id: $scope.store.id
                });

                $http.post(url, {
                    menuItemsIds: _.map($scope.menuItemsToRemove, function (menuItem) {
                        return menuItem.id;
                    })
                }).then(function (result) {
                    if (result.data.success) {
                        _.map($scope.menuItemsToRemove, function (menuItem) {
                            _.unset($scope.store.properties.menus, menuItem.id);
                            _.unset($scope.menuItemsToRemove, menuItem.id);
                        });
                    } else {
                        notifications.danger(result.data.message);
                    }
                }, function () {
                    notifications.danger("Request error");
                });
            }

            $scope.store.properties.menus = _.mapValues($scope.store.properties.menus, function (menuItem) {
                _.unset(menuItem, 'isNew');

                return menuItem;
            });

            return $scope.$parent.save(form);
        };

        $scope.reset = function () {
            $scope.menuItemsToRemove = {};

            $scope.$parent.reset();
        };

        $scope.storeChanged = function () {
            return $scope.$parent.storeChanged();
        };
    }])
    .filter('orderByItemPosition', function () {
        return function (items, reverse) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                return (a['position'] > b['position'] ? 1 : -1);
            });
            if (reverse) filtered.reverse();
            return filtered;
        };
    });
